import React from 'react';

/**
 * Covers the scoring + single write. Deliberately not a spinner — a slow
 * breathing fade on the wordmark, which reads as consideration rather than
 * processing.
 */
export const ReviewingState = () => <main className="min-h-[100dvh] bg-tns-navy flex flex-col items-center justify-center px-6 font-body" role="status" aria-live="polite" data-id="element-909" data-mp="3di5y2fhn7tyw">
    <style data-id="element-910" data-mp="3ifxqrbq43k45">
      {`
        @keyframes tns-breathe {
          0%, 100% { opacity: 0.35; letter-spacing: 0.18em; }
          50% { opacity: 1; letter-spacing: 0.24em; }
        }
        .tns-breathe { animation: tns-breathe 2.4s ease-in-out infinite; }
        @keyframes tns-rule {
          0%, 100% { transform: scaleX(0.3); opacity: 0.3; }
          50% { transform: scaleX(1); opacity: 1; }
        }
        .tns-rule { animation: tns-rule 2.4s ease-in-out infinite; }
        @media (prefers-reduced-motion: reduce) {
          .tns-breathe, .tns-rule { animation: none !important; opacity: 1 !important; }
        }
      `}
    </style>

    <p className="tns-breathe font-display text-xl sm:text-2xl uppercase text-tns-gold text-center" data-id="element-911" data-mp="23op7m8yqcehr">
      The Networking Salon
    </p>
    <span className="tns-rule block h-px w-24 bg-tns-gold mt-6 mb-8 origin-center" aria-hidden="true" data-id="element-912" data-mp="1yojmlbmytq8n" />
    <p className="font-body text-tns-ivory/70 text-center text-sm sm:text-base tracking-wide" data-id="element-913" data-mp="28ggy6jhvyk7w">
      Reviewing your fit for the ecosystem…
    </p>
  </main>;